import initMenu from "./menu";

import initDropdowns from "./dropdowns";

import initAddLinkAttributes from "./linkattributes";

import initExtractChars from "./initExtractChars";

import initModals from "./initModals";

import initGallery from "./initGallery";

import initReadTime from "./initReadTime";

import initFormResetBtn from "./formResetBtn";

import initFormSelect from "./formSelect";


import initPopup from "./popup";

import initReadMoreDescription from "./readMoreDescription";

import initMetaPixel from "./meta-pixel";

import initAcceleratorQualification from "./acceleratorQualification";

import initTabs from "./tabs";

import initCarousels from "./carousel";

import initMediaModals from "./mediaModal";

import initVideoFacades from "./videoFacade";

import initLazyRecaptcha from "./lazyRecaptcha";
/**
 * initScrolledHeader
 */
const body = jQuery("body");
const scrollChange = 10;
jQuery(window).scroll(function () {
  initScrolledHeader();
});

jQuery(document).ready(function () {
  initScrolledHeader();
});

const initScrolledHeader = () => {
  const scroll = jQuery(window).scrollTop();
  if (scroll >= scrollChange) {
    body.addClass("is-header-scrolled");
  } else {
    body.removeClass("is-header-scrolled");
  }
};

/**
* Swipey Mobile Tables
* Allows wide data tables to become horizontally swipeable on mobile devices
* ======================
*/ 
jQuery('.bbp-forums').wrap('<div class="forum-container"></div>');
jQuery('.bbp-topics').wrap('<div class="topics-container"></div>');

/**
 * Instant Page (Required)
 * When a user hovers near a link, then pre-load a page; psychological
 * effect is that user feels page load is faster.
 * @source https://instant.page
 */
import "instant.page";

/**
 * ======================
 * Load functions when page is loaded
 * ======================
 */
window.addEventListener("DOMContentLoaded", () => {
  initMenu();
  initDropdowns();
  initAddLinkAttributes();
  initExtractChars();
  initModals();
  initGallery();
  initReadTime();
  initFormResetBtn();
  initFormSelect();
  initPopup();
  initReadMoreDescription();
  initMetaPixel();
  initAcceleratorQualification();
  initTabs();
  initCarousels();
  initMediaModals();
  initVideoFacades();
  initLazyRecaptcha();
});
